module.exports = __webpack_public_path__ + "static/img/background.40782e61.svg";